import {
  CheckoutFormValues,
  CheckoutRequest,
  Plan,
} from './AccountCheckout.type';
import {getCardFlag} from '../../components';

export const mapFormValuesToCheckoutRequest = (
  values: CheckoutFormValues,
  selectedPlan: Plan,
  formToken: string,
): CheckoutRequest => {
  const {
    firstName,
    lastName,
    gender,
    email,
    cpf,
    phone,
    creditCardNumber,
    creditCardName,
    creditCardExpired,
    creditCardCvv,
    installments,
  } = values;

  const body: CheckoutRequest = {
    checkout: {
      plan_code: selectedPlan.code,
      plan: selectedPlan,
      customer: {
        name: firstName,
        last_name: lastName,
        gender: gender === 'Feminino' ? 'Feminino' : 'Masculino',
        email,
        cpf,
        phone,
      },
    },
    authenticity_token: formToken,
  };

  if (selectedPlan.store !== 'stripe') {
    body.checkout.payment = {
      credit_card_number: creditCardNumber,
      credit_card_name: creditCardName,
      expire_date: creditCardExpired,
      cvv: creditCardCvv,
      credit_card_label: getCardFlag(creditCardNumber),
      installments,
    };
  }

  return body;
};

export const formatCurrency = (value: number | string): string => {
  const numValue = typeof value === 'string' ? parseFloat(value) : value;
  return numValue.toLocaleString('pt-BR', {style: 'currency', currency: 'BRL'});
};

export const calculateInstallmentValue = (
  totalValue: number | string,
  installments: number,
): string => {
  const numValue =
    typeof totalValue === 'string' ? parseFloat(totalValue) : totalValue;
  const installmentValue = numValue / installments;
  return installmentValue.toFixed(2).replace('.', ',');
};

export const generateInstallmentsArray = (
  maxInstallments: number,
): number[] => {
  return Array.from({length: maxInstallments}, (_, i) => i + 1);
};
